<template lang="html">

  <section class="wrapper oportunidades-view">


    <section class="cuadro-intro column-center">

      <h1>Thinking<br>on working abroad?</h1>

    </section>


    <div class="wrapper-oportunidades container">

      <nav class="breadcrumb">
        <router-link :to="$t('enlaces.home')">Inicio</router-link>
        <router-link :to="$t('enlaces.oportunidadesinternacionales')">Portales globales</router-link>
      </nav>

      <div class="listado-oportunidades row-start ais">

        <article class="oportunidad-el">
          <img src="@/assets/img/Portal_Universia.png" alt="Highred">
          <h2>UNIVERSIA</h2>
          <h3>Oportunidades empleo y prácticas</h3>
          <p>Accede a ofertas de empleo y prácticas internacionales, específicas de las disciplinas ESIC o de empresas 
            que buscan talento formado en nuestra escuela.
          </p>
          <a href="https://jobboard.universia.net/esic" target="_blank" class="btn skull">Conocer más</a>
        </article>

        <article class="oportunidad-el" v-if="type == 'bs'">
          <img src="@/assets/img/oportunidad-highred.jpg" alt="Highred">
          <h2>Highered</h2>
          <h3>Prácticas y empleo junior nacional e interncaional</h3>
          <p>Gracias al acuerdo entre ESIC y la plataforma HIGHERED, estudiantes y alumni ESIC tienen acceso -con su email 
            de estudiante ESIC- a la búsqueda de prácticas y empleo junior (hasta 5 años de experiencia) a nivel internacional, 
            fundamentalmente del entorno europeo.
          </p>
          <a href="https://esic.gethighered.global/" target="_blank" class="btn skull">Conocer más</a>
        </article>

        <article class="oportunidad-el">
          <img src="@/assets/img/goinglobal.jpg" alt="GoinGlobal">
          <h2>Goinglobal</h2>
          <h3>Amplia fronteras trabajando en otros países</h3>
          <p>Como estudiante o alumni de ESIC, tienes acceso a la plataforma GoinGlobal, donde puedes consultar guías de
            búsqueda de empleo y prácticas de una larga lista de países, además de ofertas específicas para cada país.
          </p>
          <a href="https://online.goinglobal.com/default.aspx?accid=20140711wwwwwwwwwwwwvvvvvvvvwwwwwwwwwwxxxxxxxxxxxxxxxESIC" target="_blank" class="btn skull">Conocer más</a>
        </article>

<!--         <article class="oportunidad-el">
            <img src="@/assets/img/usa-careers.jpg" alt="USA Careers">
            <h2>USA Careers</h2>
            <h3>Accede al mercado laboral de Estados Unidos</h3>
            <p>Dentro del acuerdo con GoinGlobal, como alumno/a o alumni de ESIC puedes acceder a una plataforma específica sobre el mercado estadounidense.</p>
            <a href="https://online.usacareerguides.com/default.aspx?accid=20140711wwwwwwwwwwwwvvvvvvvvwwwwwwwwwwxxxxxxxxxxxxxxxESIC" target="_blank" class="btn skull">Conocer más</a>
          </article> -->



      </div>

    </div>

  </section>

</template>

<script lang="js">
  

  import {mapGetters} from 'vuex';

  export default {
    name: 'oportunidades-internacionales',
    computed :{
      ...mapGetters({
        type : 'getType'
      })
    }
  }
</script>

<style scoped lang="scss">



</style>


// WEBPACK FOOTER //
// src/components/views/oportunidades-internacionales.vue